import ExcelJS from 'exceljs';
import FileSaver  from 'file-saver';

export const generateExcel = async (excelObjectData) => {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  
   
    worksheet.mergeCells(excelObjectData.firstRowMergeCells);
    const firstHeaderRow = worksheet.getRow(1);
    firstHeaderRow.getCell(1).value = excelObjectData.firstRowText
    firstHeaderRow.getCell(1).font = { bold: true,name: 'SansSerif',size:14 };
    firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    firstHeaderRow.height = 30;
    firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).value = excelObjectData.firstRowExportDate; 
    firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).font = { bold: true,name: 'SansSerif',size:14 }; //cell No- 13
    firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    
 
   
      //excel English Column
      const headerRow2 = worksheet.addRow(excelObjectData.headerEnglishColumns);
      headerRow2.height=40;
      headerRow2.eachCell((cell,colNumber ) => {
        cell.font = { bold: true, name: 'SansSerif',size:12};
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.value = breakTitle(cell.value);
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
          
        };
        const column = worksheet.getColumn(colNumber);
        column.width = 16;
          
       });
      
 
      excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
        const dataRow = worksheet.addRow(row);
        dataRow.height=27;
        row.forEach((value, index) => {
          const cell = dataRow.getCell(index + 1);
          cell.font = {  name: 'SansSerif',size:10 };
          cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
          // Customize styling for the cells if needed
        });
       
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
      const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
      FileSaver.saveAs(blob, fileName);
  };



  export const generateCSV = async (csvObjectData) => {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(csvObjectData.sheetName);
  
   
    worksheet.mergeCells(csvObjectData.firstRowMergeCells);
    const firstHeaderRow = worksheet.getRow(1);
    firstHeaderRow.getCell(1).value = csvObjectData.firstRowText
    firstHeaderRow.getCell(1).font = { bold: true,name: 'SansSerif',size:14 };
    firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    firstHeaderRow.height = 30;
    firstHeaderRow.getCell(csvObjectData.firstRowCellNumber).value = csvObjectData.firstRowExportDate; 
    firstHeaderRow.getCell(csvObjectData.firstRowCellNumber).font = { bold: true,name: 'SansSerif',size:14 }; //cell No- 13
    firstHeaderRow.getCell(csvObjectData.firstRowCellNumber).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    
 
   
      //excel English Column
      const headerRow2 = worksheet.addRow(csvObjectData.headerEnglishColumns);
      headerRow2.height=40;
      headerRow2.eachCell((cell,colNumber ) => {
        cell.font = { bold: true, name: 'SansSerif',size:12};
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.value = breakTitle(cell.value);
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
          
        };
        const column = worksheet.getColumn(colNumber);
        column.width = 16;
          
       });
      
 
       csvObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
        const dataRow = worksheet.addRow(row);
        dataRow.height=27;
        row.forEach((value, index) => {
          const cell = dataRow.getCell(index + 1);
          cell.font = {  name: 'SansSerif',size:10 };
          cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
          // Customize styling for the cells if needed
        });
       
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
      const fileName=`${csvObjectData.fileName}.${csvObjectData.fileType}`;
      FileSaver.saveAs(blob, fileName);
  };

  
   const breakTitle = (title) => {

    const words = title.trim().split(/\s+/);
    const brokenTitle = words.reduce((result, word, index) => {
      if (index % 3 === 0) {
        return result + (index !== 0 ? '\n' : '') + word;
      } else {
        return result + ' ' + word;
      }
    }, '');
  
    return brokenTitle;
  };